<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="20">
          <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <a-form-item label="关键词" >
              <a-input v-model.trim="queryParam.keyWord" placeholder="身份证\姓名 模糊查询" />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <a-form-item label="审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-model.trim="queryParam.nameAuth" @change="installChange" :allowClear="true">
                <a-select-option v-for="type in anthNameList" :title="type.dictLabel" :key="type.dictValue">{{
                  type.dictLabel
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <a-form-item label="创建开始日期">
              <a-date-picker
                v-model="queryParam.time1"
                style="width: 100%"
                show-time
                :disabled-date="disabledStartDate"
                format="YYYY-MM-DD"
                @change="onChange1"
                @ok="onOk1"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <a-form-item label="创建结束日期">
              <a-date-picker
                v-model="queryParam.time2"
                style="width: 100%"
                show-time
                :disabled-date="disabledEndDate"
                format="YYYY-MM-DD"
                @change="onChange2"
                @ok="onOk2"
              />
            </a-form-item>
          </a-col>
          <!-- 电话号码 -->
          <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <a-form-item label="电话号码">
              <a-input v-model.trim="queryParam.phoneNumber" placeholder="电话号码" />
            </a-form-item>
          </a-col>
          <a-col
            :xs="24"
            :sm="24"
            :md="8"
            :lg="24"
            :xl="24"
            style="display:flex;justify-content:flex-end;" >
            <a-button
              type="primary"
              htmlType="submit"
              style="margin-right: 8px"
              @click="$refs.table.refresh(true)"
            >查询</a-button
            >
            <a-button style="margin-left: 8px" @click="() => (queryParam = {})">清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator"></div>
    <s-table
      size="default"
      ref="table"
      rowKey="id"
      :columns="columns"
      :data="loadData"
      bordered>
      <span slot="action" slot-scope="text, record">
        <a v-if="record.nameAuth == 2" @click="handleEdit(record.userInfoId)">审核</a>
        <a-divider v-if="record.nameAuth == 2" type="vertical" />
        <a @click="handleInfo(record.userInfoId)">详情</a>
      </span>
    </s-table>
    <idCardEdit ref="modal" @ok="handleOk" />
    <idCardInfo ref="modalInfo" @ok="handleOk" />
  </a-card>
</template>

<script>
import { STable } from '@/components'
import pick from 'lodash.pick'
import moment from 'moment'
import { queryIdCardList } from '@/api/master/idCardList'
import idCardEdit from './modules/idCardEdit.vue'
import idCardInfo from './modules/idCardInfo.vue'
import { checkPermission } from '@/utils/permissions'
import NoAuthority from '../enterprise/NoAuthority'
import { getfinddictAll } from '@/api/order/orderList'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { findByDeptId } from '@/api/master/MasterList'

export default {
  name: 'TableList',
  components: {
    STable,
    idCardEdit,
    idCardInfo,
    NoAuthority
  },
  data () {
    return {
      data: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      bisible: false,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 字典为类型
      anthNameList: [],
      // 表头
      columns: [
        {
          title: '操作',
          width: '60px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'name'
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'nameAuthName'
        },
        {
          title: '创建日期',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '地址',
          align: 'center',
          dataIndex: 'fullAdress',
          width: '300px'

        },
        {
          title: '电话号码',
          align: 'center',
          dataIndex: 'phoneNumber',
          width: '150px'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return queryIdCardList(Object.assign(parameter, this.queryParam))
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  filters: {},
  async created () {
    const dictTypes = ['anth_name']
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      this.anthNameList = res.anth_name
    })
  },

  methods: {
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    handleEdit (id) {
      this.$refs.modal.edit(id)
    },
    handleInfo (id) {
      this.$refs.modalInfo.edit(id)
    },
    handleOk () {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },

    // 品牌
    changeBrandName (e) {
      this.queryParam.brandId = e
    },

    onChange1 (value, dateString) {
      this.queryParam.startTime = dateString
    },
    onChange2 (date, dateString) {
      this.queryParam.endTime = dateString
    }
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}

</style>
